import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const successNote = (msg) => {
    toast.success(msg, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}

export const toastErrorNotify = (msg) => {
    toast.error(msg, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        // className: "custom-toast"
    });
};